/* SHARED — the dictionaries and the small pieces the card of a ticket is drawn with */

/* The states of a ticket and the colours the applications give them */
export const STATUSES = [
    { status: "WAITING", text: "Ожидает", color: "orange", accent: "orange" },
    { status: "CALLED", text: "Вызван", color: "", accent: "blue" },
    { status: "IN_SERVICE", text: "Обслуживается", color: "purple", accent: "purple" },
    { status: "DONE", text: "Завершён", color: "green", accent: "green" },
    { status: "MISSED", text: "Не пришёл", color: "red", accent: "red" },
    { status: "CANCELLED", text: "Отменён", color: "red", accent: "red" }
]

/* Where the client came from. The base keeps the value in both cases, so it is always
   read in the upper one */
export const SOURCES = {
    ADMIN: "Заведение",
    APP: "Приложение",
    WEB: "Web / QR"
}

/* What every action of the card does with the ticket. The states it may be pressed from are
   named here too, so a button which the rules of the queue forbid is never drawn */
export const ACTIONS = [
    { key: "CALLED", text: "Вызвать", icon: "notification", from: ["WAITING"], primary: true },
    { key: "IN_SERVICE", text: "Начать обслуживание", icon: "check", from: ["CALLED"], primary: true },
    { key: "DONE", text: "Завершить", icon: "check", from: ["IN_SERVICE"], primary: true },
    { key: "MISSED", text: "Не пришёл", icon: "alert", from: ["CALLED"], danger: true },
    { key: "WAITING", text: "Вернуть в ожидание", icon: "refresh", from: ["CALLED", "MISSED"] },
    { key: "CANCELLED", text: "Отменить", icon: "close", from: ["WAITING", "MISSED"], danger: true }
]

/* The events of the history — the base keeps the key, the panel says it in Russian */
export const EVENTS = {
    CREATED: "Клиент встал в очередь",
    WAITING: "Возвращён в ожидание",
    CALLED: "Клиента вызвали",
    IN_SERVICE: "Обслуживание начато",
    DONE: "Обслуживание завершено",
    MISSED: "Клиент не пришёл",
    CANCELLED: "Талон отменён",
    ASSIGNED: "Назначен мастер"
}


/* The state of one ticket — the row of the list and the card both read it through this */
export const statusOf = value => {

    const found = STATUSES.find(item => item.status === `${value}`)

    return found ? found : STATUSES[0]
}


/* Where the client came from — the value of the base as the panel says it */
export const sourceOf = value => {

    const key = `${value === null || value === undefined ? "WEB" : value}`.toUpperCase()

    return SOURCES[key] ? SOURCES[key] : key
}


/* A sum which came out of the base as a text is still a number */
export const number = value => {

    const parsed = parseFloat(value)

    if (isNaN(parsed)) {
        return 0
    }

    return parsed
}


/* A stretch of time as a human says it — "8 мин", "1 ч 20 мин" */
export const duration = minutes => {

    const value = Math.round(number(minutes))

    if (value < 1) {
        return "меньше минуты"
    }

    if (value < 60) {
        return `${value} мин`
    }

    const hours = Math.floor(value / 60)
    const rest = value % 60

    return rest > 0 ? `${hours} ч ${rest} мин` : `${hours} ч`
}


/* The icon of a ticket — it stands in place of the photo the point has not uploaded yet */
export const queueIcon = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M8.6 6.4a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Z" stroke="currentColor" strokeWidth="1.7" />
            <path d="M3.4 14.2a5.2 5.2 0 0 1 10.4 0v.9H3.4v-.9Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M17.1 9.4a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z" stroke="currentColor" strokeWidth="1.7" />
            <path d="M16.4 15.1v-.4a4.4 4.4 0 0 0-.9-2.7 4.3 4.3 0 0 1 5.1 4.3v.5h-3.4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.4 18.6h9.5M8.4 22h5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
    )
}


/* One line of the card — the name of the field and its value */
export const line = (text, value, accent = "") => {

    if (value === null || value === undefined || `${value}`.length === 0) {
        return null
    }

    return (
        <div className="queue-details-line" key={text}>
            <div className="queue-details-line-text">{text}</div>
            <div className={`queue-details-line-value ${accent}`}>{value}</div>
        </div>
    )
}
